// removed by extract-text-webpack-plugin
module.exports = {"slider":"_2cG0S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CoverPhotoEditor/Slider/Slider.scss
// module id = ./src/components/CoverPhotoEditor/Slider/Slider.scss
// module chunks = 5